import { type NodeSpec } from "prosemirror-model";

// :: NodeSpec The top level document node.
export const doc: NodeSpec = {
	// a prosemirror document may either hold
	// 1 - a document placeholder node
	// 2 - one or more nodes that are compute_cell or text_cell types
	content: "(compute_cell|block)+",
};
